import React, { Component } from 'react';
import { Grid, Button, Typography, IconButton, Icon, Checkbox, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { Dialog } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import AddItems from './scheduleComponents/AddItems';
import FourWeekBlock from './scheduleComponents/FourWeekBlock';

const styles = theme => ({

});

class ModuleSchedule extends Component {

    state = {
        // overwriteDialog
    }
    toggleDialog = () => {
        this.setState({ dialogOpen: true })
    }

    changeDialogDisplayID = (setting) => {
        setting === 'UP' ? this.setState({ dialogActiveID: this.state.dialogActiveID + 1 }) : this.setState({ dialogActiveID: this.state.dialogActiveID - 1 })
    }

    toggleMonth = (value) => {
        this.props.toggleMonth(value)
    }

    handleDuplicateCheckChange = (lesson_id, choice) => {
        this.props.handleDuplicateCheckChange(lesson_id, choice)
    }

    handleOverwriteCheckChange = (week, day, choice) => {
        this.props.handleOverwriteCheckChange(week, day, choice)
    }

    handleDuplicateSubmit = () => {
        this.props.handleDuplicateSubmit()
    }

    handleOverwriteSubmit = () => {
        this.props.handleOverwriteSubmit()
    }

    render() {
        const { classes, month, alreadySelectedModules, allModules, allLessons, course_id, mappedLessons, modulePreview, modulePreviewData, builder } = this.props
        const duplicateLessonChoices = this.props.duplicateLessons.map(lesson => {
            return (
                <div key={lesson.new.lesson_id}>
                    <h3>{lesson.new.LessonName}</h3>
                    <span>Week {lesson.new.WeekNum} Day {lesson.new.DayOfWeek}</span>
                    <Checkbox
                        checked={lesson.selected === 'NEW' ? true : false}
                        onChange={() => this.handleDuplicateCheckChange(lesson.new.lesson_id, 'NEW')}
                        value="Active"
                        color="primary"
                    />

                    <span>Week {lesson.old.WeekNum} Day {lesson.old.DayOfWeek}</span>
                    <Checkbox
                        checked={lesson.selected === 'OLD' ? true : false}
                        onChange={() => this.handleDuplicateCheckChange(lesson.old.lesson_id, 'OLD')}
                        value="Active"
                        color="primary"
                    />
                </div>
            )
        })

        const overwrittenLessonChoices = this.props.overwrittenLessons.map(lesson => {
            return (
                <div key={lesson.week + '_' + lesson.day}>
                    <p> Week: {lesson.week} Day: {lesson.day} </p>
                    <span><b>New:</b> {lesson.new.LessonName}</span>
                    <Checkbox
                        checked={lesson.selected === 'NEW' ? true : false}
                        onChange={() => this.handleOverwriteCheckChange(lesson.week, lesson.day, 'NEW')}
                        value="Active"
                        color="primary"
                    // defaultChecked={true}
                    />
                    <span><b>Old:</b> {lesson.old.LessonName}</span>
                    <Checkbox
                        checked={lesson.selected === 'OLD' ? true : false}
                        onChange={() => this.handleOverwriteCheckChange(lesson.week, lesson.day, 'OLD')}
                        value="Active"
                        color="primary"
                    />
                </div>
            )
        })

        const duplicateLessons = this.props.duplicateLessons.length > 0 ?
            <div>
                {duplicateLessonChoices}
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={() => this.handleDuplicateSubmit()}
                >
                    Submit
                </Button>
            </div> : null

        const overwrittenLessons = this.props.overwrittenLessons.length > 0 ?
            <div>
                {overwrittenLessonChoices}
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={() => this.handleOverwriteSubmit()}
                >
                    Submit
                </Button>
            </div> : null

        let monthTabs = [];
        for (var i = 1; i < Number(this.props.months) + 1; i++) {
            monthTabs.push(
                (
                    <FourWeekBlock key={i} month={i} course_id={course_id} builder={builder} />
                )
            )
        }

        return (
            <div>
                <Dialog
                    open={this.props.duplicateLessons.length > 0 && this.props.overwrittenLessons.length === 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle>Duplicate Lessons on Schedule</DialogTitle>
                    <DialogContent>
                        {/* <DialogContentText id="alert-dialog-description"> */}
                        {duplicateLessons}
                        {/* </DialogContentText> */}
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={this.props.overwrittenLessons.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle>Overwritten Lessons on Schedule</DialogTitle>
                    <DialogContent>
                        {/* <DialogContentText id="alert-dialog-description"> */}
                        {overwrittenLessons}
                        {/* </DialogContentText> */}
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={this.props.confirmDragDialog}
                    // onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Detatch Lesson from Module?"}</DialogTitle>
                    <DialogContent>
                        {/* <DialogContentText id="alert-dialog-description"> */}
                        Moving this lesson will detach it from it's parent module. It can be placed anywhere on the calendar.
                        {/* </DialogContentText> */}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.props.confirmDragAllow(true)} color="primary">
                            Allow
                        </Button>
                        <Button onClick={() => this.props.confirmDragAllow(false)} color="primary" autoFocus>
                            Go Back
                        </Button>
                    </DialogActions>
                </Dialog>

                <Grid container spacing={24}>
                    <Grid item xs={3}>
                        <Typography>Active Month:
                            <IconButton
                                onClick={(ev) => {
                                    this.toggleMonth('DOWN')
                                }}
                                disabled={this.props.month === 1}
                            >
                                <Icon>keyboard_arrow_left</Icon>
                            </IconButton>
                            {this.props.month}
                            <IconButton
                                onClick={(ev) => {
                                    this.toggleMonth('UP')
                                }}
                                disabled={this.props.month === 6}
                            >
                                <Icon>keyboard_arrow_right</Icon>
                            </IconButton>
                        </Typography>

                        <AddItems
                            mappedLessons={mappedLessons}
                            alreadySelectedModules={alreadySelectedModules}
                            allLessons={allLessons}
                            allModules={allModules}
                            course_id={course_id}
                            modulePreview={modulePreview}
                            modulePreviewData={modulePreviewData}
                            course={this.props.course}
                        />
                    </Grid>
                    <Grid item xs={9}>
                        <FourWeekBlock key={month} month={month} mappedLessons={mappedLessons} />
                    </Grid>
                </Grid>
            </div >
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleMonth: Actions.toggleMonth,
        dropModuleToDay: Actions.dropModuleToDay,
        checkDuplicateLessonConflict: Actions.checkDuplicateLessonConflict,
        checkDayLessonConflict: Actions.checkDayLessonConflict,
        handleDuplicateCheckChange: Actions.handleDuplicateCheckChange,
        handleOverwriteCheckChange: Actions.handleOverwriteCheckChange,
        handleDuplicateSubmit: Actions.handleDuplicateSubmit,
        handleOverwriteSubmit: Actions.handleOverwriteSubmit,
        confirmDragAllow: Actions.confirmDragAllow,
        dropOrphanLesson: Actions.dropOrphanLesson,
    }, dispatch);
}

function mapStateToProps({ courseApp }) {
    return {
        
    }
}

export default (withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ModuleSchedule))));


// WEBPACK FOOTER //
// src/main/content/course/CourseSchedule.js